import {TermsOfAgreement} from "./terms-of-agreement.model";
import {InformationObligation} from "./information-obligation.model";

/**
 * Złożony obiekt odpowiedzi (Response DTO) zawierający zestaw dokumentów prawnych
 * i zgód skonfigurowanych dla danego klienta.
 */
export class DocumentsResponse {

  /**
   * Lista Warunków Umowy (Terms of Agreement - TOA).
   */
  public toas: TermsOfAgreement[];

  /**
   * Lista Obowiązków Informacyjnych (Information Obligations - IOB).
   */
  public iobs: InformationObligation[];

}
